module.exports = __webpack_public_path__ + "static/colors-brand-do-5e0ea0b0e16a09a251c200527ccaad03.png";